import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { TrendingUp, Users, Building2, Network } from 'lucide-react';
interface InvestorSlide10Props {
  isDark?: boolean;
}
export function InvestorSlide10({
  isDark = false
}: InvestorSlide10Props) {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.12,
        delayChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: [0.25, 0.1, 0.25, 1]
      }
    }
  };
  const metrics = [{
    label: 'Organizations',
    value: '12+',
    icon: Building2,
    color: 'orange'
  }, {
    label: 'People Leaders',
    value: '450+',
    icon: Users,
    color: 'mint'
  }, {
    label: 'Net Revenue Retention',
    value: '115%',
    icon: TrendingUp,
    color: 'navy'
  }, {
    label: 'Provider Network',
    value: '50+',
    icon: Network,
    color: 'slate'
  }];
  return <motion.div className="h-full w-full overflow-y-auto overflow-x-hidden" variants={containerVariants} initial="hidden" animate="visible" data-id="element-156">
      <div className="min-h-full flex flex-col justify-center max-w-6xl mx-auto px-6 sm:px-12 py-20 sm:py-24" data-id="element-157">
        <motion.div variants={itemVariants} className="mb-12 sm:mb-16 text-center" data-id="element-158">
          <h1 className={`text-3xl sm:text-5xl font-bold mb-6 sm:mb-8 tracking-tight ${isDark ? 'text-white' : 'text-heliona-charcoal'}`} data-id="element-159">
            Traction
          </h1>
          <p className={`text-lg sm:text-2xl max-w-3xl mx-auto ${isDark ? 'text-white/80' : 'text-heliona-text-gray'}`} data-id="element-160">
            Early validation from forward-thinking organizations.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8 mb-16 sm:mb-20" data-id="element-161">
          {metrics.map((metric, idx) => {
          const Icon = metric.icon;
          return <motion.div key={idx} variants={itemVariants} className={`rounded-3xl p-6 sm:p-8 flex flex-col items-center text-center ${isDark ? 'bg-white/[0.03] border border-white/10' : 'bg-white border border-heliona-beige shadow-sm'}`} data-id="element-162">
                <div className={`w-14 h-14 rounded-2xl flex items-center justify-center mb-6 ${isDark ? 'bg-white/5' : `bg-heliona-${metric.color}/10`}`} data-id="element-163">
                  <Icon className={`w-7 h-7 ${isDark ? 'text-white' : `text-heliona-${metric.color === 'mint' ? 'mint-dark' : metric.color}`}`} data-id="element-164" />
                </div>
                <div className={`text-4xl font-bold mb-2 ${isDark ? 'text-white' : 'text-heliona-charcoal'}`} data-id="element-165">
                  {metric.value}
                </div>
                <p className={`text-sm font-medium ${isDark ? 'text-white/60' : 'text-heliona-text-gray'}`} data-id="element-166">
                  {metric.label}
                </p>
              </motion.div>;
        })}
        </div>

        <motion.div variants={itemVariants} className="text-center" data-id="element-167">
          <div className={`inline-flex items-center gap-3 px-6 py-3 rounded-full ${isDark ? 'bg-heliona-mint/10 text-heliona-mint' : 'bg-heliona-mint/10 text-heliona-mint-dark'}`} data-id="element-168">
            <span className="font-bold" data-id="element-169">92%</span>
            <span data-id="element-170">Helium Score completion rate across active pilots</span>
          </div>
        </motion.div>
      </div>
    </motion.div>;
}